import script from "./EditTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditTag.vue?vue&type=script&setup=true&lang=ts"

import "./EditTag.vue?vue&type=style&index=0&id=87d97df4&lang=css"

const __exports__ = script;

export default __exports__